module.exports = __webpack_public_path__ + "img/icons-fill-vehicle-sm.659d800a.svg";